<aside class="sidebar">
  <a class="brand" [routerLink]="homeRoute" aria-label="ZepBazaar dashboard">
    <img class="brand-logo brand-logo-full" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
    <img class="brand-logo brand-logo-symbol" src="/brand/symbol.png" alt="" aria-hidden="true" />
    <span class="brand-context">
      <small>{{ portalTitle }}</small>
    </span>
  </a>

  <nav class="nav" aria-label="Main navigation">
    @for (item of navItems; track item.route) {
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
        <span>{{ item.label }}</span>
      </a>
    }
  </nav>

  <div class="workspace">
    <span class="workspace-icon material-symbols-outlined" aria-hidden="true">storefront</span>
    <div>
      <strong>{{ workspaceName }}</strong>
      <small>{{ workspaceLabel }}</small>
    </div>
  </div>
</aside>
